import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProfileReportsService } from '../../services/profile-reports.service';
import { getBindings } from '@onviobr/services/session';
import { BentoModalConfirmationCloseReason, BentoModalConfirmationService } from '@bento/bento-ng';
import { ReportProfileSelected, ReportTreeTypeRefresh } from '../../models/report';
@Component({
	selector: 'app-firm-management-report-main',
	templateUrl: './firm-management-report-main.component.html',
	styleUrls: ['./firm-management-report-main.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class FirmManagementReportMainComponent implements OnInit {
	@ViewChild('ProgressPopup', { static: true }) ProgressPopup: NgbModalRef;
	@ViewChild('StatusPopup', { static: true }) StatusPopup: NgbModalRef;
	isRemoveDisabled = true;
	isLeftOpened = true;
	leftWidth = 350;
	modalInstance: NgbModalRef;
	getBindings = getBindings;
	staffId: string[] = [];
	firmId: string[] = [];
	standardId: string[] = [];
	closeResult: string;
	companyId: string;
	isLoaderBusy: boolean;
	errors: any[] = [];
	progressValue = 0;
	currentItem = 0;
	profileIds: string[];
	progressBarType = 'success';

	/** pass profile id as a input paratmeter to profile component */
	sendProfileId: string;


	get isRemoveAllowed() {
		return this.standardId.length === 0 && (this.staffId.length > 0 || this.firmId.length > 0);
	}
	get isEditAllowed() {
		return this.standardId.length === 0 && (this.staffId.concat(this.firmId).length === 1);
	}
	get profileIdSelected() {
		if (this.isEditAllowed) {
			return this.staffId.concat(this.firmId)[0];
		}
	}

	displayRightPaneContent: 'profileOption' | 'defaultText' = 'defaultText';

	/** pass selected profile info to reportoption page to display profile detail */
	selectedProfileInfo: ReportProfileSelected;

	constructor(
		public BentoModalConfirmation: BentoModalConfirmationService,
		public modalService: NgbModal,
		public profileReportService: ProfileReportsService) { }

	async ngOnInit() {
		const bindings = await this.getBindings();
		this.companyId = bindings.ApplicationConfiguration.CompanyId;
	}
	// open remove profile popup
	openRemovePopup() {
		if (!this.isRemoveAllowed) {
			return;
		}
		this.BentoModalConfirmation.open('Are you sure you want to delete the selected profile(s)?', {
			titleText: 'Remove Profile',
			confirmButtonText: 'Delete',
			buttonType: 'primary',
		}).result.then(
			(result: BentoModalConfirmationCloseReason) => {
				if (result === BentoModalConfirmationCloseReason.Confirm) {
					this.removeProfiles();
				}
			},
			() => {});
	}
	// remove selected profiles
	removeProfiles() {
		this.profileIds = this.staffId.concat(this.firmId);
		this.isLoaderBusy = true;
		this.showPopup(this.ProgressPopup);
		this.progressValue = 0;
		this.currentItem = 0;
		for (const profileId of this.profileIds) {
			this.profileReportService.removeProfile(profileId, this.companyId).subscribe(() => {
				this.progressBarType = 'success';
				this.changeProgress();
			},
			(error) => {
				this.progressBarType = 'danger';
				this.changeProgress();
				this.handleRemoveError(error);
			}
			);

		}
	}
	changeProgress() {
		this.currentItem = this.currentItem + 1;
		this.progressValue = (this.currentItem / this.profileIds.length) * 100;
		if (this.progressValue === 100) {
			this.displayRightPaneContent = 'defaultText';
			setTimeout(() => {
				this.closePopup();
				this.refreshProfiles({ isStaffChange: this.staffId.length > 0, isFirmChange: this.firmId.length > 0 });
				this.isLoaderBusy = false;
			}, 1000);
		}
	}

	openAddEditProfilePopup(content: any, action: 'add' | 'edit' = 'add') {
		/** if action for add profile than it set value as null. otherwise it give issue while edit */
		this.sendProfileId = action === 'add' ? null : this.profileIdSelected;
		this.showPopup(content, 'lg');
	}

	// to open the popup
	showPopup(content: any, size: 'sm' | 'lg' | 'xl' = 'sm') {
		this.modalInstance = this.modalService.open(content, { container: '.ng-bento', size, backdrop: 'static' });
	}
	// to close the popup
	closePopup() {
		this.modalInstance.close();
	}

	refreshProfiles(reportTreeTypeRefresh: ReportTreeTypeRefresh) {
		this.profileReportService.refreshProfile(reportTreeTypeRefresh);
		this.staffId = [];
		this.firmId = [];
	}
	// Remove profile error handler
	handleRemoveError(error: any): void {
		this.errors.push(error.error.message);
		this.showPopup(this.StatusPopup);
	}

	readStaffIds(id: string[]): void {
		this.staffId = id;
	}

	readFirmIds(id: string[]): void {
		this.firmId = id;
	}

	readStandardIds(id: string[]): void {
		this.standardId = id;
	}

	selectedProfile(profile: ReportProfileSelected) {
		if (profile.profileType !== 'Standard') {
			this.selectedProfileInfo = profile;
			this.displayRightPaneContent = 'profileOption';
		}
	}
	profileSuccess(reportTreeTypeRefresh: ReportTreeTypeRefresh) {
		this.refreshProfiles(reportTreeTypeRefresh);
	}
}
